import React, { useEffect, useState } from "react";
import {
  coerceCashierDateTimeText,
  formatCountdown,
  resolvePayDeadlineMs,
} from "./cashierDateTime";

export interface CashierCountdownProps {
  createdAt?: string | Date | null;
  expireAt?: string | Date | null;
}

export const CashierCountdown: React.FC<CashierCountdownProps> = ({
  createdAt,
  expireAt,
}) => {
  const createdAtText = coerceCashierDateTimeText(createdAt).trim();
  const expireAtText = coerceCashierDateTimeText(expireAt).trim();
  const deadlineMs = resolvePayDeadlineMs(createdAtText, expireAtText);

  const [remainingMs, setRemainingMs] = useState(() => {
    if (deadlineMs == null) {
      return 0;
    }
    return Math.max(0, deadlineMs - Date.now());
  });

  useEffect(() => {
    if (deadlineMs == null) {
      return undefined;
    }
    const tick = () => {
      setRemainingMs(Math.max(0, deadlineMs - Date.now()));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [deadlineMs]);

  if (!createdAtText && !expireAtText) {
    return null;
  }

  if (deadlineMs == null) {
    return null;
  }

  if (remainingMs <= 0) {
    return <span className="cashier-web-countdown cashier-web-countdown-expired">已过期</span>;
  }

  return (
    <span className="cashier-web-countdown">{formatCountdown(remainingMs)}</span>
  );
};
